var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "tips-fade" } }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.tipsShow,
            expression: "tipsShow",
          },
        ],
        staticClass: "tisp tips-window",
        class: _vm.tipsClass,
        attrs: { id: "tips" },
      },
      [
        _c(
          "div",
          { staticClass: "tips-icon", attrs: { "aria-hidden": "true" } },
          [
            _vm.type === "success"
              ? _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                  _c("path", {
                    attrs: {
                      d: "M9.2 16.6 4.9 12.3l-1.4 1.4 5.7 5.7L21 7.6l-1.4-1.4z",
                    },
                  }),
                ])
              : _vm.type === "error"
              ? _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                  _c("path", {
                    attrs: {
                      d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm3.5 6.9-1.4-1.4L12 9.6 9.9 7.5 8.5 8.9l2.1 2.1-2.1 2.1 1.4 1.4 2.1-2.1 2.1 2.1 1.4-1.4-2.1-2.1 2.1-2.1z",
                    },
                  }),
                ])
              : _c("svg", { attrs: { viewBox: "0 0 24 24" } }, [
                  _c("path", {
                    attrs: {
                      d: "M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20zm1 15h-2v-7h2v7zm0-9h-2V6h2v2z",
                    },
                  }),
                ]),
          ]
        ),
        _c("div", { staticClass: "tips-content" }, [
          _vm.title
            ? _c("strong", { staticClass: "tips-title" }, [
                _vm._v(_vm._s(_vm.title)),
              ])
            : _vm._e(),
          _c("p", { domProps: { innerHTML: _vm._s(_vm.message) } }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }